import { MAX_GLOBAL_SEARCH_OPTIONS } from "@/constants";
import { Icon, MenuItem } from "@trimble/modus-cmx";
import { highlightMatch } from "../../../helper";
import type { DealerOptionProps } from "../../types";
import { ViewAllOption } from "../ViewAllOption/ViewAllOption";

export function DealerOption({
  options,
  searchTerm,
  onViewAll,
}: DealerOptionProps) {
  const dealersWithMatchingSearchTerm = options.filter(
    (option) =>
      option.dealerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      option.dealerEmail.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const optionsToDisplay = dealersWithMatchingSearchTerm.slice(
    0,
    MAX_GLOBAL_SEARCH_OPTIONS
  );

  return (
    <>
      {optionsToDisplay.map((option) => (
        <MenuItem key={option.dealerId} value={option.dealerId}>
          <div slot="start-icon" className="option option--dealer">
            <Icon
              name="person"
              variant="solid"
              size="sm"
              decorative
              className="icon-color"
            />
            <div className="option-details">
              <span className="option-contract-number">
                {highlightMatch(option.dealerName, searchTerm)}
              </span>
              <span className="option-customer-name">
                {highlightMatch(option.dealerEmail, searchTerm)}
              </span>
            </div>
          </div>
        </MenuItem>
      ))}
      {dealersWithMatchingSearchTerm.length > MAX_GLOBAL_SEARCH_OPTIONS && (
        <ViewAllOption
          totalCount={dealersWithMatchingSearchTerm.length}
          onViewAll={onViewAll}
          searchCategory="dealers"
        />
      )}
    </>
  );
}
